// Competitor (competitor) form schema — the partners > prospect Informations
// schema minus "Account Manager" (business_affiliate) and "Prospect
// Provenance" (source), plus the PPTX partner fields (manager name, type).
export const competitorForm = [
  {
    type: "text",
    label: "Company name",
    name: "companyName",
    required: true,
  },
  {
    type: "text",
    label: "Company phone number",
    name: "phoneNumber",
    required: true,
  },
  {
    type: "email",
    label: "Company e-mail",
    name: "email",
    required: true,
  },
  {
    type: "text",
    label: "Website",
    name: "website",
  },
  {
    type: "text",
    label: "Code VAT",
    name: "VATCode",
  },
  {
    type: "number",
    label: "SIRET number",
    name: "siret",
  },
  {
    type: "select",
    label: "M2 in store",
    name: "storeArea",
    options: [
      { name: "Less than 50 m2", code: "Less than 50 m2" },
      { name: "50-100 m2", code: "50-100 m2" },
      { name: "100-150 m2", code: "100-150 m2" },
      { name: "150–250 m2", code: "150–250 m2" },
      { name: "250-350 m2", code: "250-350 m2" },
      { name: "More than 350 m2", code: "More than 350 m2" },
    ],
  },
  {
    type: "multiSelect",
    label: "Company activities",
    placeholder: "Select",
    name: "activities",
    appendToSelf: true,
  },
  {
    type: "number",
    label: "Number of spa in store",
    name: "spaCount",
  },
  {
    type: "number",
    label: "Number of swim spa in store",
    name: "swimSpaCount",
  },
  {
    type: "select",
    label: "Pool/Spa Group",
    placeholder: "Select",
    name: "poolSpaGroup",
    options: [
      { name: "Dejoyaux", code: "Dejoyaux" },
      { name: "Piscine Ibiza", code: "Piscine Ibiza" },
      { name: "Piscine de France", code: "Piscine de France" },
      { name: "Aboral Piscine", code: "Aboral Piscine" },
      { name: "Alliance Piscines", code: "Alliance Piscines" },
      { name: "Aquilius Piscines", code: "Aquilius Piscines" },
      { name: "Bel'O Piscine", code: "Bel'O Piscine" },
      { name: "Blue Lagoon Spas", code: "Blue Lagoon Spas" },
      { name: "Caron Piscines", code: "Caron Piscines" },
      { name: "Cocktail Piscine", code: "Cocktail Piscine" },
      { name: "EuroPiscine", code: "EuroPiscine" },
      { name: "Irripiscine", code: "Irripiscine" },
      { name: "Hydrosud", code: "Hydrosud" },
      { name: "L'eau bien être", code: "L'eau bien être" },
      { name: "L'esprit Piscine", code: "L'esprit Piscine" },
      { name: "Fusion Piscine", code: "Fusion Piscine" },
      { name: "Mondial Piscine", code: "Mondial Piscine" },
      { name: "Neptune Piscines", code: "Neptune Piscines" },
      { name: "Oasis Piscines", code: "Oasis Piscines" },
      { name: "Carré Bleu", code: "Carré Bleu" },
      { name: "Magiline", code: "Magiline" },
      { name: "Solid Pool", code: "Solid Pool" },
    ],
    filter: true,
  },
  {
    type: "multiSelect",
    label: "Sold spa brand",
    placeholder: "Select",
    name: "spaMarques",
    appendToSelf: true,
  },
  {
    type: "text",
    label: "Manager first name",
    name: "managerFirstName",
  },
  {
    type: "text",
    label: "Manager last name",
    name: "managerLastName",
  },
  {
    type: "select",
    label: "Competitor type",
    placeholder: "Select",
    name: "competitorType",
    options: [
      { name: "Direct", code: "direct" },
      { name: "Indirect", code: "indirect" },
    ],
  },
  {
    type: "select",
    label: "Busy Street / Commercial Zone",
    placeholder: "Select",
    name: "traffic",
    options: [
      { name: "Low", code: "low" },
      { name: "Medium", code: "medium" },
      { name: "High", code: "high" },
    ],
  },
  {
    type: "number",
    label: "Note on the internet",
    name: "internetNote",
    max: 5,
  },
  {
    type: "number",
    label: "Nber Fair & Show/year",
    name: "annualFairCount",
  },
  {
    type: "select",
    label: "Digital Ads",
    placeholder: "Select",
    name: "digitalAds",
    options: [
      { name: "Low", code: "low" },
      { name: "Medium", code: "medium" },
      { name: "High", code: "high" },
    ],
  },
  {
    type: "number",
    label: "Potentiel Spa/year",
    name: "annualSpaPotential",
  },
];
